// src/index.ts
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { calculatePercent, roundNumberToDigits } from "@sporkbytes/math-utils";
var maxExponent = 6;
var errors = {
    cannotParse: "Your amount could not be parsed into a floating point number. Please pass an amount that can be parsed as a float.",
    numberTooBig: "Your numbers are too big to calculate safely."
};
var Money = /*#__PURE__*/ function() {
    "use strict";
    function _Money(amount) {
        _class_call_check(this, _Money);
        var floatAmount = parseFloat(amount.toString());
        if (isNaN(floatAmount)) {
            throw new Error(errors.cannotParse);
        }
        this.amount = floatAmount;
    }
    _create_class(_Money, [
        {
            /**
   * Returns the value of the Money object rounded to the number of digits specified as a floating point number.
   * @param precision - The number of digits you want to round to.
   * @returns The amount of the Money object, rounded to the specified number of digits.
   */ key: "valueOf",
            value: function valueOf() {
                var precision = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 2;
                return roundNumberToDigits(this.amount, precision);
            }
        },
        {
            /**
   * Returns the value of the Money object rounded to the number of digits specified as a string.
   * @param precision - The number of digits you want to round to.
   * @returns The amount of the Money object, rounded to the specified number of digits.
   */ key: "toString",
            value: function toString() {
                var precision = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 2;
                return this.valueOf(precision).toString();
            }
        },
        {
            /**
   * Adds `money` to the Money object.
   * @param money - The amount to be added to the Money object.
   * This can be another Money object, a number, or a string that can be parsed into a floating point number.
   * @returns A Money object with `money` amount added to the original object.
   */ key: "add",
            value: function add(money) {
                if (!_instanceof(money, _Money)) {
                    money = new _Money(money);
                }
                var _Money_getNormalizedIntegerValues = _sliced_to_array(_Money.getNormalizedIntegerValues([
                    this.amount,
                    money.amount
                ]), 2), thisAmount = _Money_getNormalizedIntegerValues[0], thatAmount = _Money_getNormalizedIntegerValues[1];
                var sum = thisAmount + thatAmount;
                if (!_Money.numberInSafeIntegerRange(sum)) {
                    throw new Error(errors.numberTooBig);
                }
                return new _Money("".concat(sum, "e-").concat(maxExponent));
            }
        },
        {
            /**
   * Subtracts `money` from the Money object.
   * @param money - The amount to be subtracted from the Money object.
   * This can be another Money object, a number, or a string that can be parsed into a floating point number.
   * @returns A Money object with `money` amount subtracted from the original object.
   */ key: "subtract",
            value: function subtract(money) {
                if (!_instanceof(money, _Money)) {
                    money = new _Money(money);
                }
                var _Money_getNormalizedIntegerValues = _sliced_to_array(_Money.getNormalizedIntegerValues([
                    this.amount,
                    money.amount
                ]), 2), thisAmount = _Money_getNormalizedIntegerValues[0], thatAmount = _Money_getNormalizedIntegerValues[1];
                var difference = thisAmount - thatAmount;
                if (!_Money.numberInSafeIntegerRange(difference)) {
                    throw new Error(errors.numberTooBig);
                }
                return new _Money("".concat(difference, "e-").concat(maxExponent));
            }
        },
        {
            /**
   * Multiplies `money` by the Money object's value.
   * @param money - The amount to be multiplied with the Money object.
   * This can be another Money object, a number, or a string that can be parsed into a floating point number.
   * @returns A Money object with `money` amount multiplied by the original object's value.
   */ key: "multiply",
            value: function multiply(money) {
                if (!_instanceof(money, _Money)) {
                    money = new _Money(money);
                }
                var _Money_getNormalizedIntegerValues = _sliced_to_array(_Money.getNormalizedIntegerValues([
                    this.amount,
                    money.amount
                ]), 2), thisAmount = _Money_getNormalizedIntegerValues[0], thatAmount = _Money_getNormalizedIntegerValues[1];
                var product = thisAmount * thatAmount;
                if (!_Money.numberInSafeIntegerRange(product)) {
                    throw new Error(errors.numberTooBig);
                }
                return new _Money("".concat(product, "e-").concat(maxExponent * 2));
            }
        },
        {
            /**
   * Adds `percent` of the original Money object to the Money object.
   * This is handy for calculating taxes.
   * @param percent - The percentage amount to be added to the Money object.
   * @returns A Money object with `percent` amount added to the original object.
   */ key: "addPercent",
            value: function addPercent(percent) {
                var amountToAdd = calculatePercent(this.amount, percent);
                return this.add(amountToAdd);
            }
        },
        {
            /**
   * Subtracts `percent` of the original Money object from the Money object.
   * This is handy for calculating discounts.
   * @param percent - The percentage amount to be subtracted from the Money object.
   * @returns A Money object with `percent` amount subtracted from the original object.
   */ key: "subtractPercent",
            value: function subtractPercent(percent) {
                var amountToSubtract = calculatePercent(this.amount, percent);
                return this.subtract(amountToSubtract);
            }
        }
    ], [
        {
            key: "getNormalizedIntegerValues",
            value: /**
   * Given an array of numbers, return an array with the numbers represented as integers.
   * @private
   * @param numbers - An array of numbers to be converted to integers.
   * @returns The array of numbers converted to integers.
   */ function getNormalizedIntegerValues(numbers) {
                return numbers.map(function(num) {
                    return Math.round(Number("".concat(num, "e").concat(maxExponent)));
                });
            }
        },
        {
            key: "numberInSafeIntegerRange",
            value: /**
   * Checks whether the given number is in the range of safe integers.
   * @private
   * @param number - The number to check.
   * @returns Whether the given number is in the range of safe integers.
   */ function numberInSafeIntegerRange(number) {
                return number < Number.MAX_SAFE_INTEGER && number > Number.MIN_SAFE_INTEGER;
            }
        }
    ]);
    return _Money;
}();
var index_default = Money;
export { index_default as default };
